module.exports = __webpack_public_path__ + "static/media/film-alt.eca7af70.svg";